var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Gift = function Gift(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.338 7A3.5 3.5 0 0 1 7.49 2c1.32-.02 2.522.626 3.465 1.674.394.438.743.944 1.044 1.503a7.712 7.712 0 0 1 1.044-1.503C13.987 2.626 15.19 1.98 16.509 2a3.5 3.5 0 0 1 3.153 5H20a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h.338Zm3.18-3c.606-.01 1.291.279 1.951 1.012.452.502.856 1.177 1.173 1.988H7.5a1.5 1.5 0 1 1 0-3h.017Zm8.979 3h.003a1.5 1.5 0 0 0 0-3h-.017c-.607-.01-1.292.279-1.952 1.012-.453.502-.856 1.177-1.173 1.988h3.139ZM5 11H4V9h7v2H5Zm1 8v-6h5v7H7a1 1 0 0 1-1-1Zm11 1h-4v-7h5v6a1 1 0 0 1-1 1Zm2-9h-6V9h7v2h-1Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Gift;